import GameScene from "../scenes/GameScene";
import { GameObject } from "./GameObject";

export class Flag extends GameObject {
	stars: Phaser.GameObjects.Container[] = [];
	enabled = true;

	flagEmitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];
	constructor(scene: GameScene, x: number, y: number) {
		super(scene);
		this.x = x;
		this.y = y;

		scene.physics.world.enableBody(this, Phaser.Physics.Arcade.STATIC_BODY);
		const body = this.body as Phaser.Physics.Arcade.StaticBody;
		body.setSize(50, 100, false);
		const dx = -(body.position.x - this.x);
		const dy = -(body.position.y - this.y);
		body.setOffset(dx - body.width / 2, dy - body.height / 2);

		for (let i = 0; i < 2; i++) {
			const pole = new GameObject(this.scene);
			const poleImg = pole.addImage("flag" + scene.level.name);
			poleImg.setOrigin(0.5, 1);
			if (i == 0) pole.setPosition(x + 30, y - 80);
			else pole.setPosition(x - 30, y + 140);
			this.scene.addObject(pole, "game");
			if (i == 0) this.createStars();
		}
	}

	createStars(): void {
		const container = new GameObject(this.scene);
		container.setPosition(this.x, this.y);

		const offset = { x: 15, y: 60 };
		const startY = 100 - offset.y;
		const startX = -30 + offset.x;
		for (let i = 0; i < 3; i++) {
			const starGroup = this.scene.add.container(startX + i * offset.x, startY - i * offset.y);
			container.add(starGroup);

			const star = this.scene.add.image(0, 0, "pickupStar");
			starGroup.add(star);
			star.setOrigin(0.5);
			this.scene.add.tween({
				targets: star,
				y: { from: -10, to: 10 },
				ease: Phaser.Math.Easing.Quadratic.InOut,
				yoyo: true,
				repeat: -1,
			});

			const particles = [this.scene.add.particles("sparkle1"), this.scene.add.particles("sparkle2")];
			for (let i = 0; i < 2; i++) {
				const manager = particles[i];
				starGroup.add(manager);

				const emitter = manager.createEmitter({ frequency: 500, delay: Phaser.Math.RND.integerInRange(0, 100) });
				emitter.setLifespan(1000);
				emitter.setGravity(0, 0);
				emitter.setSpeedX({ min: -10, max: 10 });
				emitter.setSpeedY({ min: -10, max: 10 });
				emitter.setAngle({ min: 0, max: 359 });
				emitter.onParticleEmit(this.onParticleEmit, this);
				emitter.tint.onUpdate = this.onParticleUpdate;
				this.flagEmitters.push(emitter);
			}

			this.stars.push(starGroup);
		}
		this.scene.addObject(container, "game");
	}

	onParticleEmit(particle: Phaser.GameObjects.Particles.Particle): void {
		const strength = Phaser.Math.RND.realInRange(10, 50);
		const angle = Phaser.Math.RND.rotation();
		particle.x = Math.cos(angle) * strength;
		particle.y = Math.sin(angle) * strength;
		(<any>particle).rotVel = Phaser.Math.RND.realInRange(1, 4);
		(<any>particle).scale = Phaser.Math.RND.realInRange(1, 1.2);
		particle.scaleX = 0;
		particle.scaleY = 0;
	}

	onParticleUpdate(particle: Phaser.GameObjects.Particles.Particle): number {
		const scale = (<any>particle).scale as number;
		if (particle.lifeCurrent < 300) {
			const progress = Phaser.Math.Clamp(particle.lifeCurrent / 300, 0, 1);
			particle.scaleX = scale * progress;
			particle.scaleY = scale * progress;
		} else if (particle.scaleX != scale) {
			particle.scaleX = scale;
			particle.scaleY = scale;
		}

		const rotVel = (<any>particle).rotVel as number;
		particle.rotation = (particle.lifeCurrent / 1000) * rotVel;

		const fadeOutStart = particle.life - 300;
		if (particle.lifeCurrent >= fadeOutStart) {
			const progress = Phaser.Math.Clamp((particle.lifeCurrent - fadeOutStart) / 300, 0, 1);
			particle.alpha = 1 - progress;
		}
		return 0xffffff;
	}

	onHit(): void {
		this.enabled = false;
		for (let i = 0; i < this.stars.length; i++) {
			const star = this.stars[i];

			this.scene.tweens.killTweensOf(star.getAt(0));
			star.parentContainer.remove(star);
			this.scene.hudContainer.add(star);

			let point = new Phaser.Math.Vector2();
			point = this.parentContainer
				.getWorldTransformMatrix()
				.transformPoint(this.x + star.x, this.y + star.y, point) as Phaser.Math.Vector2;
			point.set(point.x - this.scene.cameras.main.scrollX, point.y);
			star.setPosition(point.x, point.y);

			this.scene.tweens.add({
				targets: star,
				x: this.scene.ui.scoreGroup.x - this.scene.ui.scoreGroup.width * 0.3,
				y: this.scene.ui.scoreGroup.y,
				duration: 800,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
			this.scene.tweens.add({
				targets: star,
				scale: 0,
				duration: 300,
				delay: 500,
				ease: Phaser.Math.Easing.Quadratic.Out,
				onComplete: star.destroy,
				onCompleteScope: star,
			});
		}
		this.stars = [];
	}

	onPause(): void {
		for (const starGroup of this.stars) {
			const particles = starGroup
				.getAll()
				.filter(
					(obj) => obj instanceof Phaser.GameObjects.Particles.ParticleEmitterManager
				) as Phaser.GameObjects.Particles.ParticleEmitterManager[];

			for (const manager of particles) {
				manager.pause();
			}
		}
		for (const emitter of this.flagEmitters) {
			emitter.pause();
		}
	}

	onResume(): void {
		for (const starGroup of this.stars) {
			const particles = starGroup
				.getAll()
				.filter(
					(obj) => obj instanceof Phaser.GameObjects.Particles.ParticleEmitterManager
				) as Phaser.GameObjects.Particles.ParticleEmitterManager[];

			for (const manager of particles) {
				manager.resume();
			}
		}
		for (const emitter of this.flagEmitters) {
			emitter.resume();
		}
	}
}
